<template>
  <div class="pagesTips" :style="{ color }">
    <h5 v-if="showTitle">
      <i class="iconfont iconu268"></i>
      <span>温馨提示</span>
    </h5>
    <!-- <div class="contents" v-html="content" slot=""></div> -->
    <slot name="content" class="contents" />
  </div>
</template>
<script>
export default {
  props: {
    color: String,
    content: {
      type: String,
      default: "",
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped lang="less">
.pagesTips {
  font-size: var(--smallFont);
  line-height: 1.5em;
  color: #999;
  margin: 16px 0px;
  box-sizing: border-box;
  h5 {
    font-size: 13px;
    .iconfont {
      float: left;
      margin-right: 8px;
      // margin-top: 1px;
      font-size: 18px;
    }
  }
  .contents {
    color: #7f7f7f;
    margin: 5px 2px;
    font-size: 13px;
  }
}
</style>
